var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_view)?_c('div',{staticClass:"quick"},[_c('ul',{staticClass:"text-center"},[_c('li',[_c('button',{on:{"click":_vm.toCall}})]),_c('li',[_c('button',{on:{"click":_vm.toQna}})]),_c('li',[_c('button',{on:{"click":_vm.toPdt}})]),_c('li',[_c('button',{on:{"click":_vm.toTop}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }